const ENVIRONMENT = `${process.env.REACT_APP_STAGE || ''}`.trim();

export const LOCAL_HOST = 'http://localhost:8081';
export const IS_LOCAL_ENVIRONMENT = ENVIRONMENT === 'local';
export const API_BASE_URL = IS_LOCAL_ENVIRONMENT ? LOCAL_HOST : '';

const { origin = '' } = window.location;
export const FILE_HOST = IS_LOCAL_ENVIRONMENT ? LOCAL_HOST : origin;
export const ACCESS_TOKEN = '{ACCESS_TOKEN_HERE}';

export const B2B_ENABLED = window.env.FEATURE_B2B_ENABLED
? window.env.FEATURE_B2B_ENABLED === 'true'
: false;
